module.exports = __webpack_public_path__ + "static/media/ben-shushan.cf518785.jpg";